import API from 'services/api.services';
import { ChatbotConfig } from 'constants/chat.constants';
import { setChatConfig } from 'state/reducers/chatbot.reducers';
import { setLoading } from 'state/reducers/chatbot.reducers';

// API endpoint constants - these should normally be in db.constants.ts
const API_CHATBOT_CONFIG = '/chatbot/config';

/**
 * Service for communicating with the chatbot backend API
 */
export const getChatbotConfig = () => {
	return async (dispatch: any, getState: any) => {
		const { user } = getState();
		const userDetails = user.details!;

		dispatch(setLoading(true));

		const userEmail = userDetails.email;
		const content = {
			companyId: userDetails.companyId,
			companyName: userDetails.companyName,
			phone: userDetails.phone,
			firstName: userDetails.given_name,
			lastName: userDetails.family_name,
		};
		await API.getInstance()
			.post(API_CHATBOT_CONFIG, { userEmail, content })
			.then((response) => dispatch(setChatConfig(response.data.config)))
			.catch((error) => {
				console.error('Error fetching chatbot config:', error);
			})
			.finally(() => {
				dispatch(setLoading(false));
			});
		// }
	};
};
